import { render, staticRenderFns } from "./modalNews.vue?vue&type=template&id=28f689e6"
import script from "./modalNews.vue?vue&type=script&lang=js"
export * from "./modalNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports